import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs/Observable";
import {
  RequestDetailDto,
  RequestAddDto,
  RequestDeleteDraftDto,
  RequestSaveDto,
} from "../dto/overtime-cancel.dto";

@Injectable()
export class OvertimeCancelApi {

  private readonly service: string = '';
  private readonly model: string = 'sf6s/overtimeCancel';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public detail(payload: RequestDetailDto): Observable<any> {
    const method: string = 'GET';
    const func: string = 'detail';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public add(payload: RequestAddDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public deleteDraft(payload: RequestDeleteDraftDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'deleteDraft';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public save(payload: RequestSaveDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'save';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public feedOvtCancel(requestNo: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'feedOvtCancel';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/overtime-cancel.api.ts